// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2Yt4v","col":"styles_col__3E5Dr"};